export function getIrr(values: Array<number>, guess_in: number) {


    // Calculates the first derivation
    const dates: Array<number> = [];
    let positive = false;
    let negative = false;
    for (let i = 0; i < values.length; i++) {
      dates[i] = (i === 0) ? 0 : dates[i - 1] + 365;
      if (values[i] > 0) {positive = true; }
      if (values[i] < 0) {negative = true; }
    }

    // Return error if values does not contain at least one positive value and one negative value
    if (!positive || !negative) {
        return '#NUM!';
    }

    // Initialize guess and resultRate
    const guess = (typeof guess_in === 'undefined') ? 0.1 : guess_in;
    let resultRate = guess;

    // Set maximum epsilon for end of iteration
    const epsMax = 1e-10;

    // Set maximum number of iterations
    const iterMax = 50;

    // Implement Newton's method
    let newRate, epsRate, resultValue;
    let iteration = 0;
    let contLoop = true;
    do {
      resultValue = irrResult(values, dates, resultRate);
      newRate = resultRate - resultValue / irrResultDeriv(values, dates, resultRate);
      epsRate = Math.abs(newRate - resultRate);
      resultRate = newRate;
      contLoop = (epsRate > epsMax) && (Math.abs(resultValue) > epsMax);
    } while (contLoop && (++iteration < iterMax));

    if (contLoop) {
        return '#NUM!';
    }

    // Return internal rate of return
    return resultRate;
  }

function irrResult(vals: Array<number>, dates: Array<number>, rate: number) {
    const r = rate + 1;
    let result = vals[0];
    for (let i = 1; i < vals.length; i++) {
      result += vals[i] / Math.pow(r, (dates[i] - dates[0]) / 365);
    }
    return result;
}

function irrResultDeriv(vals: Array<number>, dates: Array<number>, rate: number) {
    const r = rate + 1;
    let result = 0;
    for (let i = 1; i < vals.length; i++) {
      const frac = (dates[i] - dates[0]) / 365;
      result -= frac * vals[i] / Math.pow(r, frac + 1);
    }
    return result;
  }
